var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col" },
    [
      _c(
        "div",
        { staticClass: "bg-transparent md:bg-white p-0 md:p-5 rounded" },
        [
          _vm.showOrgImage
            ? _c("div", { staticClass: "block md:hidden mb-10" }, [
                _c("img", { attrs: { alt: "Organization", src: _vm.imgSrc } }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "h2",
            {
              staticClass:
                "text-2.5xl font-sans-bold text-n-gray-dark font-hairline mb-6",
            },
            [_vm._v("\n      " + _vm._s(_vm.organization.name) + "\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex" }, [
            _c("div", { staticClass: "w-full md:w-1/2" }, [
              _c("div", { staticClass: "pl-4" }, [
                _vm.hasCompleted
                  ? _c("div", [
                      _vm.organization.city
                        ? _c("div", [
                            _vm._v(_vm._s(_vm.organization.city)),
                            _vm.organization.state
                              ? _c("span", [
                                  _vm._v(", " + _vm._s(_vm.organization.state)),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.country && _vm.country.name
                        ? _c("div", [_vm._v(_vm._s(_vm.country.name))])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.organization.url
                        ? _c(
                            "div",
                            [
                              _c(
                                "NewTabA11y",
                                { attrs: { href: _vm.organization.url } },
                                [_vm._v("Website")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.organization.publicEmail
                        ? _c("div", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: `mailto:${_vm.organization.publicEmail}`,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.organization.publicEmail) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _c("div", [_vm._m(0)]),
              ]),
            ]),
            _vm._v(" "),
            _vm.showOrgImage
              ? _c(
                  "div",
                  { staticClass: "hidden md:block w-1/2 text-right pr-4" },
                  [
                    _c("img", {
                      staticClass: "text-right",
                      attrs: {
                        src: _vm.imgSrc,
                        alt: "Profile shot",
                        width: "175",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", [
            !_vm.hasCompleted
              ? _c("div", { staticClass: "mb-4 pl-4 mt-4 md:mt-0" }, [
                  _vm._v("\n        Add your social links\n      "),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-row space-x-2 mb-4 pl-4 mt-4" },
              [
                _c("SocialIcon", {
                  attrs: {
                    "has-completed": _vm.hasCompleted,
                    type: "instagram",
                    link: _vm.organization.instagramUrl,
                  },
                }),
                _vm._v(" "),
                _c("SocialIcon", {
                  attrs: {
                    "has-completed": _vm.hasCompleted,
                    type: "facebook",
                    link: _vm.organization.facebookUrl,
                  },
                }),
                _vm._v(" "),
                _c("SocialIcon", {
                  attrs: {
                    "has-completed": _vm.hasCompleted,
                    type: "twitter",
                    link: _vm.organization.twitterUrl,
                  },
                }),
                _vm._v(" "),
                _c("SocialIcon", {
                  attrs: {
                    "has-completed": _vm.hasCompleted,
                    type: "linkedin",
                    link: _vm.organization.linkedinUrl,
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mt-0 md:mt-5 pl-0" }, [
        _c(
          "div",
          { staticClass: "flex flex-wrap" },
          [
            _c(
              "EventEditBtn",
              {
                attrs: { completed: _vm.hasCompleted },
                on: {
                  click: function ($event) {
                    _vm.modalOpen = true
                  },
                },
              },
              [_vm._v("\n        Add your details\n      ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "px-3" }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "button button-secondary button__medium mb-2",
                attrs: { href: _vm.organization.profileUrl },
              },
              [_vm._v("\n          View Profile\n        ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("OrganizationEditModal", {
        model: {
          value: _vm.modalOpen,
          callback: function ($$v) {
            _vm.modalOpen = $$v
          },
          expression: "modalOpen",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h3",
      {
        staticClass: "text-n-gray-dark text-2xl font-hairline",
        staticStyle: { "line-height": "32px" },
      },
      [
        _vm._v("\n              Add your "),
        _c("br"),
        _vm._v("details here\n            "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }